import { iTableFilterDef } from "../../hooks/useTableFilters";
import { iFlatEvent } from "../../types/eventTypes";
import PhCalendarBlankSvg from "../../assets/svg-fc/PhCalendarBlankSvg";
import PhMapPinSvg from "../../assets/svg-fc/PhMapPinSvg";
import PhStackSvg from "../../assets/svg-fc/PhStackSvg";
import PhForkKnifeSvg from "../../assets/svg-fc/PhForkKnifeSvg";
import PhUsersThreeSvg from "../../assets/svg-fc/PhUsersThreeSvg";
import PhXCircleSvg from "../../assets/svg-fc/PhXCircleSvg";

const text = (value: string | null | undefined, empty: string) => [value?.trim() || empty];

/**
 * The consumer event lists' filter pills. Keys are the row fields saved filters name (city, occasionType, serviceType,
 * kindOfFood, customerName, eventDate), so filters saved from the old grid still load.
 */
const EVENT_FILTERS: iTableFilterDef<iFlatEvent>[] = [
	{
		key: "eventDate",
		kind: "dateRange",
		label: "Event date",
		icon: <PhCalendarBlankSvg size={16} />,
		getDate: (row) => row.eventDate,
	},
	{ key: "city", label: "City", icon: <PhMapPinSvg size={16} />, get: (row) => text(row.city, "Not set") },
	{
		key: "occasionType",
		label: "Occasion type",
		icon: <PhStackSvg size={16} />,
		get: (row) => text(row.occasionType, "Not set"),
	},
	{
		key: "serviceType",
		label: "Service type",
		icon: <PhForkKnifeSvg size={16} />,
		get: (row) => text(row.serviceType, "Not set"),
	},
	{
		key: "kindOfFood",
		label: "Type of food",
		icon: <PhForkKnifeSvg size={16} />,
		get: (row) => (row.kindOfFood?.length ? row.kindOfFood : ["Not set"]),
	},
	{
		key: "customerName",
		label: "Customer",
		icon: <PhUsersThreeSvg size={16} />,
		get: (row) => text(row.customerName, "Not set"),
	},
	{
		key: "declinedBy",
		label: "Declined by",
		icon: <PhXCircleSvg size={16} />,
		get: (row) => text(row.declinedBy, "Not set"),
	},
];

/** The pills for the columns a list shows. */
export const getEventFilterDefs = (columnKeys: string[]) => EVENT_FILTERS.filter((def) => columnKeys.includes(def.key));
